import { updateMerchantPayoutStatus } from 'APIs/merchants/merchants';
import { PayoutStatusUpdateRequest } from 'APIs/merchants/merchants.types';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import PayoutStatusUpdateModal from './PayoutStatusUpdateModal';

type Props = {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  postPayoutStatusUpdate?: () => void;
};

const MultipleMerchantPayoutStatus = ({ showModal, setShowModal, postPayoutStatusUpdate }: Props) => {
  const { apiBaseUri } = useSelector((state: ReduxStateType) => ({
    apiBaseUri: state.apiBaseUri,
  }));

  const [isModalLoading, setIsModalLoading] = useState<boolean>(false);

  const updatePayoutStatus = useCallback(
    async (merchantId: string, toggleStatus: boolean) => {
      if (!apiBaseUri) {
        return false;
      }
      let success = false;
      setIsModalLoading(true);

      try {
        const payoutStatusUpdateRequest: PayoutStatusUpdateRequest = {
          payoutStatus: toggleStatus ? 'Enabled' : 'Disabled',
        };
        await updateMerchantPayoutStatus(apiBaseUri, merchantId, payoutStatusUpdateRequest);
        success = true;
      } catch (e) {
        success = false;
      } finally {
        setIsModalLoading(false);
      }
      return success;
    },
    [apiBaseUri],
  );

  return (
    <>
      {showModal && (
        <PayoutStatusUpdateModal
          updatePayoutStatus={updatePayoutStatus}
          isModalLoading={isModalLoading}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
};

export default MultipleMerchantPayoutStatus;
